module.exports = __webpack_public_path__ + "static/img/img-metodologia-3.8479bce5.jpg";